import { render, staticRenderFns } from "./video-poster.vue?vue&type=template&id=6cb28289&"
import script from "./video-poster.vue?vue&type=script&lang=js&"
export * from "./video-poster.vue?vue&type=script&lang=js&"
import style0 from "./video-poster.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports